import { StandardEvents } from '@shopify/events';
// Add compatibility notifications only. Horizon remains authoritative for
// selected variant, price, gallery, form submission, cart events and UI updates.
if (!window.mrProductLegacyEventsReady) {
  window.mrProductLegacyEventsReady = true;
  document.addEventListener(StandardEvents.productSelect, event => {
    const section = event.target instanceof Element ? event.target.closest('.shopify-section') : null;
    if (!section?.querySelector('.mr-product-compatibility-marker')) return;
    event.promise?.then(({ detail }) => {
      if (!detail) return;
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: detail.resource, productId: detail.productId } }));
    }).catch(error => {
      if (error?.name !== 'AbortError') console.warn('[MR product compatibility]', error);
    });
  });
}
